import type { MenuTriggerProps } from 'react-aria-components/Menu';
import { MenuTrigger as RACMenuTrigger } from 'react-aria-components/Menu';

export const MenuTrigger: React.FC<MenuTriggerProps> = ({
  children,
  ...props
}) => {
  return <RACMenuTrigger {...props}>{children}</RACMenuTrigger>;
};
